<template>
  <div>
    <div class="PcDevice_block">
      <div class="d-flex align-items-center mb-4">
        <img src="../assets/images/user.svg" class="mr-3" style="width: 50px; height: 50px" alt="" />
        <div>
          <h4>ลงทะเบียนสมาชิกฟรี</h4>
          <h6>ชมนิทรรศการสะดวกยิ่งขึ้น ข่าวสารอุตสาหกรรมราบรื่นยิ่งขึ้น</h6>
        </div>
      </div>
      <p>
        Receive our latest exhibition updates, redeem ticket events, exclusive member discounts, and subscribe to our
        newsletter and exhibition newsletter for free.
      </p>
      <a href="https://www.chanchao.com.tw/accounts/th/signup" class="btn btn-block btn-secondary mt-3"
        >ลงทะเบียนทันที</a
      >

      <hr />
    </div>
    <h4 class="my-4">คำถามที่พบบ่อย</h4>

    <ul class="ml-0 pl-4">
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87_En.pdf"
          target="_blank"
          >วิธีเข้าร่วมสมาชิก?</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8_En.pdf"
          target="_blank"
          >วิธีขอตั๋ว? อะไรคือการเข้างานด้วยโค้ดเชิญชวน?</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8_En.pdf"
          target="_blank"
          >วิธีสแกนเข้างานด่วน?</a
        >
      </li>
    </ul>

    <div class="d-flex mt-3">
      <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
        >คำถามที่พบบ่อยเพิ่มเติม<i class="fas fa-external-link-alt ml-2"></i
      ></a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },

    methods: {},

    created() {},
  }
</script>

<style scoped lang="scss"></style>
